import React from 'react';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}

/**
 * Componente de imagem otimizado para SEO e performance
 * Implementa lazy loading e fallback para imagens
 */
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  objectFit = 'cover'
}) => {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      className={`${className}`}
      style={{ objectFit }}
      onError={(e) => {
        e.currentTarget.src = '/placeholder-game.jpg';
        e.currentTarget.onerror = null; // previne loop infinito se a imagem de fallback também falhar
      }}
    />
  );
};

export default OptimizedImage; 